import { Chip, Grid2, Icon } from '@aibees/shared/components';
import { useCreditUsageItems } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, Divider, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { CreditRulesProps as Props } from './types';

export const CreditRules = memo(({ className }: Props) => {
  const { items } = useCreditUsageItems();

  return (
    <Styled.Wrapper
      className={classnames('CreditRules', className)}
      sx={SX.root}
      variant="outlined"
    >
      {items.map((item, index) => (
        <Box key={item.title}>
          <Grid2 columns={48} container sx={SX.item}>
            <Grid2 xs={33} direction="row" gap={0.5} alignItems="center">
              <Box>
                <Icon name="info" size={16} color="primary.400" />
              </Box>
              <Typography variant="body4" fontWeight={400} color="gray.700">
                {item.title}
              </Typography>
            </Grid2>
            <Grid2 xs={15} justifyContent="flex-end">
              <Chip
                variant="filled"
                size="small"
                startIcon={item.credit !== 0 ? 'coin' : undefined}
                label={
                  <>
                    {item.credit !== 0 && <>{' ✕ '}</>}
                    {item.credit !== 0 ? item.credit : 'Free'}
                  </>
                }
              ></Chip>
            </Grid2>
          </Grid2>
          {index < items.length - 1 && <Divider sx={SX.divider} />}
        </Box>
      ))}
    </Styled.Wrapper>
  );
});

CreditRules.displayName = 'CreditRules';
